import PropTypes from 'prop-types';
import React from 'react';

// eslint-disable-next-line import/no-cycle
import { LumberDeckingCalculator } from '../../composites/LumberDeckingCalculator';

const CMSLumberDeckingCalculator = ({ copy }) => <LumberDeckingCalculator copy={copy} />;

export default CMSLumberDeckingCalculator;

CMSLumberDeckingCalculator.propTypes = {
  copy: PropTypes.shape({
    prehead: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    heading: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    bodyCopy: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  }).isRequired,
};
